import "./banner";
import "./blogs";
import "./comment";
import "./setting";
import "./about";
import "./project";
import "./message";
import Mock from "mockjs";
Mock.setup({
  timeout: "1000-2000",
});
